import { capitalize } from './capitalize';

export const capitalizeAll = (str: string): string =>
  String(str)
    .split(' ')
    .map((word) => capitalize(word))
    .join(' ');
